import { addRegionalSuffix } from 'approot/shared/helmet/helmet';
import LayoutMeta from 'approot/shared/layout/layout-meta';
import { useRegionData } from 'approot/shared/region/region.apollo';
import { ActivitiesContentType, LESSON_ACTIVITIES } from 'global/constants';

type Props = {
  name: string;
  contentType: ActivitiesContentType;
  noIndex?: boolean;
};

const ActivityPresentMeta = ({ name, contentType, noIndex }: Props) => {
  const { region } = useRegionData();

  return (
    <LayoutMeta
      meta={{
        robots: noIndex ? 'noindex, nofollow' : undefined,
        name: addRegionalSuffix({
          title: `${name} ${
            contentType === LESSON_ACTIVITIES ? 'Lesson' : 'Assessment'
          } | Inquisitive`,
          region,
        }),
      }}
    />
  );
};

export default ActivityPresentMeta;
